// extracted by mini-css-extract-plugin
export default {"ChartContainer":"Statistics_User_ChartContainer__h4M7v","SelecterContainer":"Statistics_User_SelecterContainer__JvRhE","Select":"Statistics_User_Select__ApjiI"};